import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navigation from './components/Navigation.jsx';
import Footer from './components/Footer.jsx';
import Home from './pages/Home.jsx';
import AboutUs from './pages/AboutUs.jsx';
import AreasOfPractice from './pages/AreasOfPractice.jsx';
import Lawyers from './pages/Lawyers.jsx';
import Internship from './pages/Internship.jsx';
import Careers from './pages/Careers.jsx';
import Blog from './pages/Blog.jsx';
import ContactUs from './pages/ContactUs.jsx';
import './App.css';
import ScrollToTop from "./components/ScrollToTop";


function App() {
  return (
    <Router>
      <ScrollToTop /> 
      <div className="App">
        <Navigation />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/areas-of-practice" element={<AreasOfPractice />} />
            <Route path="/lawyers" element={<Lawyers />} />
            <Route path="/internship" element={<Internship />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/contact-us" element={<ContactUs />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
